import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import {Angulartics2} from 'angulartics2';
import { HybridToolsService } from '../../../../core/services/hybrid-tools.service';
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-first-hours',
  templateUrl: './first-hours.component.html',
  styleUrls: ['../participants-resources.scss']
})
export class FirstHoursComponent implements OnInit, AfterViewInit {
  @Input() data: any = {};
  constructor(private angulartics2: Angulartics2, private hybridToolsService: HybridToolsService) { }

  ngOnInit() {
    this.angulartics2.eventTrack.next({
      action: 'View Quick Start Guide',
      properties: {category: 'Fundraising Toolbox: Get Started'}
    });
  }

  ngAfterViewInit() {
    const that = this;
    $('.first-hours a').each(function (item) {
      $(this).attr('data-link', $(this).attr('href')).removeAttr('href');
      $(this).addClass('link');
      $(this).bind('click', function () {
        that.hybridToolsService.openExternalLink($(this).attr('data-link'));
      });
    });
  }

}
